import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";

const StyledSwitch = withStyles({
  root: {
    width: 42,
    height: 22,
    padding: 0,
    display: "flex",
    alignItems: "center"
  },
  switchBase: {
    padding: 3,
    color: "#ffffff",
    "&$checked": {
      transform: "translateX(20px)",
      color: "#ffffff",
      "& + $track": {
        backgroundColor: "#007BC0 !important",
        opacity: "1 !important",
        border: "none"
      }
    }
  },
  thumb: {
    width: 16,
    height: 16,
    boxShadow: "none",
    backgroundColor: "#ffffff"
  },
  track: {
    borderRadius: 11,
    opacity: "1 !important",
    backgroundColor: "#BFC0C2",
    boxSizing: "border-box"
  },
  checked: {}
})(Switch);

function CustomSwitch(props) {
  return <StyledSwitch {...props} />;
}

export { CustomSwitch };
export default CustomSwitch;
